import useProductConfiguration from "../../../../../hooks/useProductConfiguration";
import SummaryValues from "./SummaryValues";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const Summary = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const productName = searchParams.get("product_name") || "";

  const {
    getFinalVariantConfigurations,
    updatedVariantConfigurations,
    selectedAttributeValues,
  } = useProductConfiguration();

  // Debug what Summary receives when it mounts
  useEffect(() => {
    console.log("🎯 SUMMARY MOUNTED");
    console.log(
      "🎯 selectedAttributeValues in Summary:",
      selectedAttributeValues
    );
    Object.keys(selectedAttributeValues).forEach((attrName) => {
      console.log(
        `🎯 ${attrName}:`,
        selectedAttributeValues[attrName].map((v) => v.attribute_value_name)
      );
    });
  }, [selectedAttributeValues]);

  // Use getFinalVariantConfigurations to get pre-populated data if it exists
  const config = getFinalVariantConfigurations(productName);

  // Debug logging
  console.log(
    "Summary component - updatedVariantConfigurations:",
    updatedVariantConfigurations
  );
  console.log(
    "Summary component - config from getFinalVariantConfigurations:",
    config
  );

  return (
    <div>
      <SummaryValues config={config} />
    </div>
  );
};

export default Summary;
